// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoverageEligibilityRequestModel {
    static getAttributeTypeMap() {
        return PayorCoverageEligibilityRequestModel.attributeTypeMap;
    }
}
PayorCoverageEligibilityRequestModel.discriminator = undefined;
PayorCoverageEligibilityRequestModel.attributeTypeMap = [
    {
        "name": "payorCoverageAreaId",
        "baseName": "payorCoverageAreaId",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    }
];
//# sourceMappingURL=payorCoverageEligibilityRequestModel.js.map